/**
 * Функция-стратегия (State Machine)
 * Определяет, какой режим интерфейса должен быть активен.
 *
 * Возвращает объект: { mode: string, type?: string }
 * mode: 'LOADING' | 'THEME_SELECT' | 'SYSTEM' | 'BLOCKER' | 'EVENT' | 'GAMEPLAY'
 */
export const getUiState = ({
    game,
    mafia,
    isRole,
    isGhost,
    spectatorAccess,
    hasActiveMinigame,
    roleSeen,
    interrogationWelcomeSeen,
    menu
}) => {

  const isAccessDenied = !isRole && !spectatorAccess?.allowed;

    // 1. ПРОВЕРКА НА ОШИБКИ И ЗАГРУЗКУ

    // Если объекта game вообще нет - это начальная загрузка
    if (!game) return { mode: 'LOADING' };

    // Если сервер вернул ошибку (например, { error: 'notFound' })
    if (game.error) return { mode: 'SYSTEM', type: 'NOT_FOUND' };

    // 2. Выбор темы
    if (game.mode === 'mafia' && !menu.activeTheme) return { mode: 'THEME_SELECT' };

    // Конец игры или бан
    if (game.finished || mafia.phase === 'end') return { mode: 'SYSTEM', type: 'GAME_OVER' };
    
    if (isAccessDenied) return { mode: 'SYSTEM', type: 'ACCESS_DENIED' };

    // 2. Ветка ЗРИТЕЛЯ / ПРИЗРАКА
    // Зрители игнорируют фазы обсуждения и голосования, они всегда в игре
    if (isGhost) {
        if (!roleSeen) return { mode: 'EVENT', type: 'GHOST_WELCOME' };
        return { mode: 'GAMEPLAY' };
    }

    // 3. Ветка ИГРОКА: События (Интерактивные окна)
    // Активный допрос (если еще не скрыл приветствие)
    if (mafia.nightState?.activeInterrogation && !interrogationWelcomeSeen) {
        return { mode: 'EVENT', type: 'INTERROGATION' };
    }
    // Карточка роли (если еще не видел)
    if (!roleSeen) return { mode: 'EVENT', type: 'ROLE_REVEAL' };

    // 4. Ветка ИГРОКА: Блокирующие фазы

    // Обсуждение
    if (mafia.phase === 'discussion') return { mode: 'BLOCKER', type: 'DISCUSSION' }

    // Голосование
    if (mafia.phase === 'voting') return { mode: 'BLOCKER', type: 'VOTING' };

    // Мирный житель во время хода мафии (если нет мини-игры)
    if (mafia.phase === 'draw_mafia' && mafia.role === 'civilian' && !hasActiveMinigame) {
        return { mode: 'BLOCKER', type: 'CIVILIAN_WAITING' };
    }

    // Мирный житель спит ночью
    if (mafia.phase === 'night' && mafia.role === 'civilian' && !hasActiveMinigame) {
        return { mode: 'BLOCKER', type: 'NIGHT_SLEEP' };
    }

    // 5. Обычный геймплей
    return { mode: 'GAMEPLAY' };
};